import { graphql } from './graphql.js';

// Platform-level GraphQL surface (not stream-specific). Currently:
//   - opcos: list of operating businesses from sfc-shared-db
//
// Separate from per-stream API modules so it stays clearly platform-scoped.

export interface Opco {
  readonly id: string;
  readonly name: string;
  readonly shortCode: string;
  readonly isActive: boolean;
}

const OPCOS_QUERY = `
  query Opcos {
    opcos {
      id
      name
      shortCode
      isActive
    }
  }
`;

export async function fetchOpcos(): Promise<ReadonlyArray<Opco>> {
  const { opcos } = await graphql<{ opcos: Opco[] }>(OPCOS_QUERY);
  return opcos;
}
